import CavesServices from "./CavesServices.js";

export default {
  getAllAddress(params) {
    return CavesServices.getEndpointForAddress(
      "postcodes/",
      params,
      "/addresses/byfield?fields=grid_east,grid_north,w3w,SubBuilding,Building,PostTown,Thoroughfare"
    );
  },
};
